// extracted by mini-css-extract-plugin
export var button = "_n2-0";